import React from 'react';
import styled from 'styled-components';
import { List, Grid3x3 } from 'lucide-react';
import { theme } from '../styles/theme';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing[1]};
  gap: ${theme.spacing[1]};
`;

const ToggleButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing[2]};
  padding: ${theme.spacing[2]} ${theme.spacing[3]};
  background: ${({ $active }) => $active ? theme.colors.primary[100] : 'transparent'};
  color: ${({ $active }) => $active ? theme.colors.primary[700] : theme.colors.textMuted};
  border: none;
  border-radius: ${theme.borderRadius.md};
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  cursor: pointer;
  transition: all ${theme.transitions.base};
  min-width: 80px;
  
  &:hover {
    background: ${({ $active }) => $active ? theme.colors.primary[100] : theme.colors.primary[50]};
    color: ${({ $active }) => $active ? theme.colors.primary[700] : theme.colors.primary[600]};
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const ToggleLabel = styled.span`
  @media (max-width: ${theme.breakpoints.sm}) {
    display: none;
  }
`;

interface ViewToggleProps {
  viewMode: 'list' | 'grid';
  onViewModeChange: (mode: 'list' | 'grid') => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <ToggleContainer>
      <ToggleButton
        $active={viewMode === 'list'}
        onClick={() => onViewModeChange('list')}
        title="List View"
      >
        <List size={16} />
        <ToggleLabel>List</ToggleLabel>
      </ToggleButton>
      
      <ToggleButton
        $active={viewMode === 'grid'}
        onClick={() => onViewModeChange('grid')}
        title="Grid View"
      >
        <Grid3x3 size={16} />
        <ToggleLabel>Grid</ToggleLabel>
      </ToggleButton>
    </ToggleContainer>
  );
};

export default ViewToggle;